import React, { useEffect, useState } from 'react';
import './app.css';
import './style/base.css';
import './style/utils.css';
import { Provider } from 'react-redux';
import { store } from './store/index';

import FlashComponent from './components/topVideo.tsx';
import Navigation from './components/navigation.jsx';
import Footer from './components/footer/footer';
import GuestBotLoader from './components/guestbot/GuestBotLoader';
import Items from './components/items/items';
import PatientsProvider from '../src/store/patientsProvider';
import { ResourcesProvider } from './store/resourcesProvider';
import AuthProvider from '../src/store/authProvider';
import { AlertProvider } from './components/ui/alertProvider';

function App() {
    const [forecasts, _setForecasts] = useState();
    const _arr = [{ country: 'usa', id:5 }, { country: 'Italy', id: 7 }, {country: 'Israel', id: 6 }];

    const arr1 = [{ country: 'usa', id: 5 }, { country: 'Italy', id: 7 }, { country: 'Israel', id: 6 }];

    const swap = (array, i, j) => {
        const temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }

    useEffect(() => {
       // populateWeatherData();
       
    }, []);
    const _sortByName = (array) => {
        console.log(array);
        array.sort((a, z) => a['country'].localeCompare(z['country']));
        console.log(array);

    }
    //sortByName(arr);
    const sortArray = (array) => {
        console.log("Sorting array:", array);
        for (var i = 0; i < array.length; i++) {
            for (var j = 0; j < array.length - i - 1; j++) {
                if (array[j].id > array[j + 1].id) {
                    swap(array, j, j + 1);
                }
            }
        }
        console.log("Sorted array:", array);
    }

    sortArray(arr1);

    
    
    const _contents = forecasts === undefined
        ? <p><em>Loading... Please refresh once the ASP.NET backend has started. See <a href="https://aka.ms/jspsintegrationreact">https://aka.ms/jspsintegrationreact</a> for more details.</em></p>
        : <table className="table table-striped" aria-labelledby="tableLabel">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Temp. (C)</th>
                    <th>Temp. (F)</th>
                    <th>Summary</th>
                </tr>
            </thead>
            <tbody>
                {forecasts.map(forecast =>
                    <tr key={forecast.date}>
                        <td>{forecast.date}</td>
                        <td>{forecast.temperatureC}</td>
                        <td>{forecast.temperatureF}</td>
                        <td>{forecast.summary}</td>
                    </tr>
                )}
            </tbody>
        </table>;

    return (
        <Provider store={store}>
            <AlertProvider>
                <AuthProvider >
                    <PatientsProvider  >
                        <ResourcesProvider>
                        <div className="app-frame">
                                <Navigation />
                                {/* Main content anchor for skip link */}
                                <main id="main" tabIndex={-1}>
                                </main>
                                {/* Accessibility toolbar (fixed) */}
                                <div style={{ position: 'fixed', bottom: 12, left: 12, zIndex: 10000 }}>
                                    <React.Suspense fallback={null}>
                                        {/* lazy dynamic import for AccessibilityToolbar */}
                                        {React.createElement(React.lazy(() => import('./components/accessibility/AccessibilityToolbar')))}
                                    </React.Suspense>
                                </div>
                                <GuestBotLoader />
                                <Footer />
                               
                        </div>
                        </ResourcesProvider>
                    </PatientsProvider>
                </AuthProvider>
            </AlertProvider>
        </Provider>
    );
    

    
}

export default App;